import Vue from 'vue';

Vue.component('vuetable-price-override', () =>
    import(/* webpackChunkName: 'price-override-index' */ './vuetable-price-override.vue'),
);
